(function () {
  'use strict';

  /* @ngdoc object
   * @name autoRosterSchedule
   * @description
   *
   */
  angular
    .module('autoRosterSchedule', [
      'ui.router'
    ]);
}());
